import { normalizeNewLines } from "@/lib/utils/reminderEmailBody";

export interface EventInfoItem {
  label: string;
  value: string | undefined | null;
}

export const buildEventInfoItems = (params: {
  title?: string | null;
  description?: string | null;
  datetimeLabel?: string | null;
  url?: string | null;
  offlineLocation?: string | null;
  translate: (key: string) => string;
}): EventInfoItem[] => {
  const { title, description, datetimeLabel, url, offlineLocation, translate } =
    params;
  return [
    { label: translate("eventManage.eventTitle"), value: title || "-" },
    {
      label: translate("eventManage.eventDescriptionLabel"),
      value: description ? normalizeNewLines(description) : "-",
    },
    {
      label: translate("eventManage.eventDatetime"),
      value: datetimeLabel || "-",
    },
    {
      label: translate("eventManage.eventOfflineLocation"),
      value: offlineLocation || "-",
    },
    { label: translate("eventManage.eventUrl"), value: url || "-" },
  ];
};
